import { createTheme } from '@mui/material'

import { components } from './components'
import { palette } from './palette'
import { shadows } from './shadows'
import { typography } from './typography'

/** In px */
export const SPACING_UNIT = 4

export const cybusTheme = createTheme({
    spacing: SPACING_UNIT,
    typography,
    palette,
    shadows,
    components,
    transitions: { duration: { enteringScreen: 240, leavingScreen: 180 } },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            /** Original value was 1200 */
            lg: 1280,
            xl: 1536,
        },
    },
})
